import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import BarChart from 'components/@common/Charts/BarChart';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import { WdtStudentModuleProgressData } from 'types/schema-generated-types';
import { ModuleType } from '../../../../types';
import { merge } from 'lodash';
import { PrintViewContext } from 'components/ReportsModule/providers/PrintViewProvider';
import {
  BAR_CHART_COMMON_OPTIONS,
  MODULE_LENGTH_MAP,
  MODULE_LEVELS_COLOR_MAP
} from '../../../../utils/report-wdt-utils';

interface ActivitiesCompletedCharacterCardProps {
  module: ModuleType;
  reportData: WdtStudentModuleProgressData[];
  loading: boolean;
}

const ActivitiesCompletedCharacterCard: React.FC<ActivitiesCompletedCharacterCardProps> = ({
  module,
  reportData,
  loading
}) => {
  const { t } = useTranslation('Reports');
  const { cardChartWidth } = useContext(PrintViewContext);

  const moduleReportData = reportData.filter(item => item.module === module);

  const series = [
    {
      name: '1 Star',
      data: moduleReportData
        .filter(item => item.level === 1)
        .map(item => item.charactersCompletedCount)
    },
    {
      name: '2 Stars',
      data: moduleReportData
        .filter(item => item.level === 2)
        .map(item => item.charactersCompletedCount)
    },
    {
      name: '3 Stars',
      data: moduleReportData
        .filter(item => item.level === 3)
        .map(item => item.charactersCompletedCount)
    }
  ];

  const options = merge({}, BAR_CHART_COMMON_OPTIONS, {
    colors: MODULE_LEVELS_COLOR_MAP[module],
    yaxis: {
      forceNiceScale: false,
      min: 0,
      max: MODULE_LENGTH_MAP[module],
      title: { text: 'No. of Characters' }
    },
    xaxis: { categories: ['1 Star', '2 Stars', '3 Stars'] },
    stroke: {
      show: true,
      colors: ['transparent'],
      width: 8
    }
  });

  return (
    <ReportCard
      title={t(`${t(module, { ns: 'ModuleType' })} Activities Completed`)}
      helpText={t(`wdtStudentActivitiesCompleted-${module}`, { ns: 'ReportsHelpCommon' })}
      loading={loading}
      reportData={reportData}
    >
      <BarChart height={200} width={cardChartWidth} series={series} options={options} />
    </ReportCard>
  );
};

export default React.memo(ActivitiesCompletedCharacterCard);
